import { useState } from "react";

import { dispatch } from "../../state/store";
import {
  setFWUVersionsLoadingChanges,
  setFWUVersionsRefresh,
  setFWUVersionToEdit
} from "../../state/ducks";

import { strCode } from "../../consts";
import { fwuVersionsService, log, notificationService, t } from "../../services";
import { uploadFWUFile } from "./useCreateFWUVersion";

export const useUpdateFWUVersion = () => {
  const [loading, setLoading] = useState(false);

  const mutationCallback = async (packageId, binFile, signatureFile) => {
    if (binFile?.uploaded && signatureFile?.uploaded) {
      return;
    }

    try {
      setLoading(true);
      dispatch(setFWUVersionsLoadingChanges(true));

      const res = await fwuVersionsService.getFileUploadUrls(packageId);

      const binFileUrl = res?.data?.data?.binary_upload_uri;
      const signatureFileUrl = res?.data?.data?.signature_upload_uri;

      if (binFileUrl && !binFile?.uploaded) {
        await uploadFWUFile(binFileUrl, binFile);
      }

      if (signatureFile && !signatureFile?.uploaded) {
        await uploadFWUFile(signatureFileUrl, signatureFile);
      }

      notificationService.showSuccess({
        title: t(strCode.UPDATE_FWU_VERSION_SUCCESS),
        message: t(strCode.UPDATE_FWU_VERSION_SUCCESS_INFO)
      });

      dispatch(setFWUVersionToEdit(null));
      dispatch(setFWUVersionsRefresh(true));
    } catch (error) {
      log.error("useUpdateFWUVersion: Failed to update fwu version", error);
      notificationService.showError({
        title: t(strCode.UPDATE_FWU_VERSION_ERROR),
        message: error?.response?.data?.message ? error.response.data.message : error?.toString()
      });
    } finally {
      dispatch(setFWUVersionsLoadingChanges(false));
      setLoading(false);
    }
  };

  return { mutationCallback, loading };
};
